
<div class="search-input-container" :disabled="disabled" :size="size" :data-shape="shape">
	<div class="search-meta-wrapper" :disabled="disabled">
		<div v-if="showSearchIcon" class="search-icon">
			<Icon :name="icon" type="filled" :size="iconSizes[size]" :effects="false" />
		</div>
		<div v-if="$slots['default']" class="search-by-dropdown" :showSearchIcon="showSearchIcon">
			<!-- @slot Used to display 'Search By' dropdown-->
			<slot />
		</div>
	</div>
	<div class="search-input-box">
		<input
			ref="search-input"
			v-model="innerValue"
			:placeholder="placeholder"
			:disabled="disabled"
			:data-qa-field="dataQaField"
			@click="handleClick"
			@change="handleChange"
			@keyup="handleKeyUp"
			@focus="focusSearch"
			@blur="blurSearch"
		/>

		<svg
			:visible="showClear"
			x="0px"
			class="search-clear"
			y="0px"
			viewBox="0 0 60 60"
			xml:space="preserve"
			stroke-width="8px"
			data-qa-field="search-clear"
			@click="clearSearch"
		>
			<path class="stroke" d="M56,4L4,56" />
			<path class="stroke" d="M56,56L4,4" />
		</svg>
	</div>
	<div v-if="noResultTag" class="search-nor-result-tag">
		<Tag size="small">
			<span class="upper-case fc-warning">{{ noResultText }}</span>
		</Tag>
	</div>
	<div v-if="$slots['autocomplete']" class="search-input-autocomplete">
		<div v-if="autoCompleteHeader" class="search-input-autocomplete-header">
			<slot name="autocomplete-header">
				<p class="paragraph-3 upper-case fc-light">RECENT SEARCH</p>
			</slot>
		</div>
		<slot name="autocomplete" />
	</div>
</div>
